import { forwardRef } from 'react';
import type { SidebarContainerProps } from '../../../../../types/sidebar.types';

export const SidebarContainer = forwardRef<
  HTMLDivElement,
  SidebarContainerProps
>(({ children, onPointerChange }, ref) => {
  return (
    <div
      ref={ref}
      onMouseEnter={() => onPointerChange(true)}
      onMouseLeave={() => onPointerChange(false)}
      className="relative h-full min-w-[400px] overflow-y-auto px-3 pt-4 md:h-screen lg:overflow-y-auto lg:overflow-x-hidden"
      id="sidebar-container"
    >
      {children}
    </div>
  );
});

SidebarContainer.displayName = 'SidebarContainer';
